// @ts-nocheck
import React, { useState } from 'react';
import { FC } from 'react';
import { useEffect } from 'react';
import ClearDataButton from './ClearDataButton';
import { useRef } from 'react';

export interface LocationInputProps {
  defaultValue: string;
  onChangeParent?: (value: string) => void;
  onInputDone?: (value: string) => void;
  placeHolder?: string;
  desc?: string;
  className?: string;
  autoFocus?: boolean;
  suggestions?: any[];
  // suggestionIds?: number[];
  // suggestionsArray?: object[];
}

const LocationInput: FC<LocationInputProps> = ({
  defaultValue,
  autoFocus = false,
  onChangeParent,
  onInputDone,
  placeHolder = 'Location',
  desc = 'Where are you searching?',
  className = 'nc-flex-1.5',
  suggestions,
  suggestionIds,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState(defaultValue);
  const [showPopover, setShowPopover] = useState(autoFocus);

  const [filteredSuggestions, setFilteredSuggestions] = useState(['']);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [input, setInput] = useState('');
  const suggestionsState = useState(suggestions);

  const [citySuggestions, setCitySuggestions] = useState(
    suggestions.map(function (item: any) {
      return item['cityName'];
    })
  );

  //let citySuggestions;

  // console.log('SUGGESTIONS S T A T E---->>');
  // console.log(citySuggestions);

  // console.log('SUGGESTIONS ---->>>>>>>>>>');
  // console.log(citySuggestions);

  const onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const userInput = e.currentTarget.value;

    if (suggestions) {
      let citySuggestions = suggestions.map(function (item: any) {
        return item['cityName'];
      });
      // Filter our suggestions that don't contain the user's input

      // console.log('City suggestions: ');
      // console.log(citySuggestions);
      const unLinked = citySuggestions.filter(
        (suggestion) =>
          suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
      );
      //console.log(unLinked);

      setInput(e.currentTarget.value);
      setValue(e.currentTarget.value);
      setFilteredSuggestions(unLinked);
      setActiveSuggestionIndex(0);
      setShowSuggestions(true);
    }
    // working?
    //onChangeParent(e);
  };

  // const onClick = (e: React.FormEvent<HTMLInputElement>) => {
  //   setFilteredSuggestions([]);
  //   setInput(e.currentTarget.innerText);
  //   setActiveSuggestionIndex(0);
  //   setShowSuggestions(false);
  // };

  // const onKeyDown = (e: React.KeyboardEvent<object>) => {
  //   // User pressed the enter key
  //   if (e.key === 'Enter') {
  //     setInput(filteredSuggestions[activeSuggestionIndex]);
  //     setActiveSuggestionIndex(0);
  //     setShowSuggestions(false);
  //   }
  //   // User pressed the up arrow
  //   else if (e.key === 'ArrowRight') {
  //     if (activeSuggestionIndex === 0) {
  //       return;
  //     }

  //     setActiveSuggestionIndex(activeSuggestionIndex - 1);
  //   }
  //   // User pressed the down arrow
  //   else if (e.key === 'ArrowDown') {
  //     if (activeSuggestionIndex - 1 === filteredSuggestions.length) {
  //       return;
  //     }

  //     setActiveSuggestionIndex(activeSuggestionIndex + 1);
  //   }
  // };

  useEffect(() => {
    setCitySuggestions(
      suggestions.map(function (item: any) {
        return item['cityName'];
      })
    );
  }, [suggestions]);

  useEffect(() => {
    setInput(defaultValue);
    // citySuggestions = suggestions.map(function (item: any) {
    //   return item['cityName'];
    // });
    // setCitySuggestions(
    //   suggestions.map(function (item: any) {
    //     return item['cityName'];
    //   })
    // );
    // setCitySuggestions(
    //   suggestions.map(function (item: any) {
    //     return item['cityName'];
    //   })
    // );
    // console.log(citySuggestions);
  }, [defaultValue]);

  useEffect(() => {
    setShowPopover(autoFocus);
    // setCitySuggestions(
    //   suggestions.map(function (item: any) {
    //     return item['cityName'];
    //   })
    // );
  }, [autoFocus]);

  useEffect(() => {
    if (eventClickOutsideDiv) {
      document.removeEventListener('click', eventClickOutsideDiv);
    }
    showPopover && document.addEventListener('click', eventClickOutsideDiv);
    return () => {
      document.removeEventListener('click', eventClickOutsideDiv);
    };
  }, [showPopover]);

  useEffect(() => {
    onChangeParent && onChangeParent(value);
  }, [value, input]);

  useEffect(() => {
    if (showPopover && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showPopover]);

  const eventClickOutsideDiv = (event: MouseEvent) => {
    if (!containerRef.current) return;
    // CLICK IN_SIDE
    if (!showPopover || containerRef.current.contains(event.target as Node)) {
      return;
    }
    // CLICK OUT_SIDE
    setShowPopover(false);
  };

  const handleSelectLocation = (item: string) => {
    setInput(item);
    setValue(item);
    onInputDone && onInputDone(item);
    setShowPopover(false);
  };

  const renderTopCities = () => {
    return (
      <>
        <h3 className='block mt-2 sm:mt-0 px-4 sm:px-8 font-semibold text-base sm:text-lg text-neutral-800 dark:text-neutral-100'>
          Top cities
        </h3>
        <div className='mt-2'>
          {/* {[
            'Hamptons, Suffolk County, NY',
            'Las Vegas, NV, United States',
            'Ueno, Taito, Tokyo',
            'Ikebukuro, Toshima, Tokyo',
          ].map((item) => ( */}
          {citySuggestions
            ?.filter((_, i) => i < 6)
            .map((item) => (
              // console.log('recent'),
              // console.log(citySuggestions),
              <span
                onClick={() => handleSelectLocation(item)}
                key={item}
                className='flex px-4 sm:px-8 items-center space-x-3 sm:space-x-4 py-4 sm:py-5 hover:bg-neutral-100 dark:hover:bg-neutral-700 cursor-pointer'
              >
                <span className='block text-neutral-400'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-4 sm:h-6 w-4 sm:w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={1.5}
                      d='M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z'
                    />
                  </svg>
                </span>
                <span className=' block font-medium text-neutral-700 dark:text-neutral-200'>
                  {item}
                </span>
              </span>
            ))}
        </div>
      </>
    );
  };

  const renderSearchValue = () => {
    return (
      <>
        {filteredSuggestions.map((item) => (
          <span
            onClick={() => handleSelectLocation(item)}
            key={item}
            className='flex px-4 sm:px-8 items-center space-x-3 sm:space-x-4 py-4 sm:py-5 hover:bg-neutral-100 dark:hover:bg-neutral-700 cursor-pointer'
          >
            <span className='block text-neutral-400'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-4 w-4 sm:h-6 sm:w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={1.5}
                  d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'
                />
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={1.5}
                  d='M15 11a3 3 0 11-6 0 3 3 0 016 0z'
                />
              </svg>
            </span>
            <span className='block font-medium text-neutral-700 dark:text-neutral-200'>
              {item}
            </span>
          </span>
        ))}
      </>
    );
  };

  return (
    <div className={`relative flex ${className}`} ref={containerRef}>
      <div
        onClick={() => setShowPopover(true)}
        className={`flex flex-1 relative [ nc-hero-field-padding ] flex-shrink-0 items-center space-x-3 cursor-pointer focus:outline-none text-left  ${
          showPopover ? 'nc-hero-field-focused' : ''
        }`}
      >
        <div className='text-neutral-300 dark:text-neutral-400'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='nc-icon-field'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={1.5}
              d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'
            />
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={1.5}
              d='M15 11a3 3 0 11-6 0 3 3 0 016 0z'
            />
          </svg>
        </div>
        <div className='flex-grow'>
          <input
            className={`block w-full bg-transparent border-none focus:ring-0 p-0 focus:outline-none focus:placeholder-neutral-300 xl:text-lg font-semibold placeholder-neutral-800 dark:placeholder-neutral-200 truncate`}
            placeholder={placeHolder}
            // value={value}
            autoFocus={showPopover}
            // onChange={(e) => setValue(e.currentTarget.value)}
            ref={inputRef}
            onChange={onChange}
            // onKeyDown={onKeyDown}
            value={input}
          />
          <span className='block mt-0.5 text-sm text-neutral-400 font-light '>
            <span className='line-clamp-1'>{!!input ? placeHolder : desc}</span>
          </span>
          {input && showPopover && (
            <ClearDataButton
              onClick={() => {
                setInput('');
                setValue('');
              }}
            />
          )}
        </div>
      </div>
      {/* {console.log('shoppopower - input')}
      {console.log(showPopover, input)} */}
      {showPopover && (
        <div className='absolute left-0 z-40 w-full min-w-[300px] sm:min-w-[500px] bg-white dark:bg-neutral-800 top-full mt-3 py-3 sm:py-6 rounded-3xl shadow-xl max-h-96 overflow-y-auto'>
          {input !== '' ? renderSearchValue() : renderTopCities()}
        </div>
      )}
    </div>
  );
};

export default LocationInput;
